import get from 'lodash/get';
import {EVENT_TYPES, SMS_STATUS_CHECK_FAILED_ERROR} from '../../services/ts-sms/ts-sms.settings';
import {ITranslate} from '../../services/LocalizationService';
import {ISmsStatusDetails} from './_contracts/SendSmsStatus';

export interface ISmsProgressStatus {
    name: string;
    messageDetails?: ISmsStatusDetails;
}

/**
 * Failures that say nothing about the number itself - the SMS may well have arrived, we just
 * couldn't tell. Offering to change the number would be as misleading as claiming the send failed.
 */
const ERRORS_UNRELATED_TO_THE_NUMBER = [SMS_STATUS_CHECK_FAILED_ERROR];

/** The agent-facing message for the failure the given event carries, translated. */
export function extractSmsSendingError(details: ISmsStatusDetails | undefined, translate: ITranslate): string {
    const errorMessage = get(details, 'customError') || get(details, 'smsError.Message') || '';

    return translate(errorMessage);
}

export function shouldOfferNumberChange(details: ISmsStatusDetails | undefined): boolean {
    return !ERRORS_UNRELATED_TO_THE_NUMBER.includes(get(details, 'smsError.Message', ''));
}

/** The explanation shown under a failed step in the invite wizard, if the failure carries one. */
export function getSmsErrorSubLabel(status: ISmsProgressStatus, translate: ITranslate): string | undefined {
    if (status.name !== EVENT_TYPES.ERROR) {
        return undefined;
    }

    const errorMessage = extractSmsSendingError(status.messageDetails, translate);

    return errorMessage || undefined;
}
